import { createSelector } from '@ngrx/store';
import { selectShare } from './share.selector';

export const selectTodos = createSelector(
  selectShare,
  (share:any) => {
    const {result:{entities}} = share;
    if (!entities || !entities.todos) {
      return [];
    }
    return Object.keys(entities.todos)
      .map((key) => entities.todos[key]);
  }
);
